import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/shared/base-service/base-service.service';
import { Equipamento } from '../interfaces/equipamento';
import { SelectConfig } from 'src/app/shared/components/form-control/form-control.component';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService extends BaseService<Equipamento> {

  constructor(protected http: HttpClient) {
    super(http, 'equipamentos');
  }

  selectConfig: SelectConfig = {
    label: 'nome',
    value: 'id',
    optionDetails: [
      { prop: 'descricao' }
    ],
    clearable: true,
    searchable: true,
    fnSearch: (term: string, item: Equipamento) => {
      term = term.toLocaleLowerCase().replace(/[/\.-]/g, "");
      return (item.nome && item.nome.toLocaleLowerCase().includes(term)) ||
        (item.descricao && item.descricao.toLocaleLowerCase().includes(term));
    }
  };

  getByCategoria(categoriaId: number) {
    return this.http.get<Equipamento[]>(`${this.apiUrl}/${this.apiPrefix}/${this.apiEndpoint}/categoria/${categoriaId}`);
  }
}
